import { render } from "./TransactionBox.vue?vue&type=template&id=bb33b7e2&scoped=true"
import script from "./TransactionBox.vue?vue&type=script&lang=js"
export * from "./TransactionBox.vue?vue&type=script&lang=js"

import "./TransactionBox.vue?vue&type=style&index=0&id=bb33b7e2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb33b7e2"]])

export default __exports__